import { render, staticRenderFns } from "./law.vue?vue&type=template&id=8579ce74&scoped=true&"
import script from "./law.vue?vue&type=script&lang=js&"
export * from "./law.vue?vue&type=script&lang=js&"
import style0 from "./law.vue?vue&type=style&index=0&id=8579ce74&lang=less&scoped=true&"
import style1 from "./law.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8579ce74",
  null
  
)

export default component.exports